import React from "react";
import { useWatch } from "react-hook-form";

import FormInputEmail from "components/Form/Input/Email";
import FormInputText from "components/Form/Input/Text";
import FormTitle from "components/Form/Title";
import FormErrors from "pages/ApplicationForm/components/FormErrors";
import { StepProps } from "../../types";
import { LABELS } from "./labels";
import FormInputCurrency from "components/Form/Input/Currency";
import FormInputRadio from "components/Form/Input/Radio";
import { WEB_URLS } from "settings";

const STEP_KEY = "broker";

const BrokerDetailsForm: React.FC<StepProps> = ({
  control,
  register,
  errors,
  setValue,
}) => {
  const brokerFeeAddedToLoan = useWatch({
    name: `${STEP_KEY}.brokerFeeAddedToLoan`,
    control: control,
  });
  const lenderFeeAddedToLoan = useWatch({
    name: `${STEP_KEY}.lenderFeeAddedToLoan`,
    control: control,
  });

  return (
    <div className="flex flex-col space-y-4">
      <FormTitle left border title="Broker Details" mb={false} />

      <FormErrors formErrors={errors?.[STEP_KEY]} />

      <FormInputText
        id={`${STEP_KEY}.name`}
        label={LABELS.name}
        register={register}
        requiredField={false}
        error={errors?.[STEP_KEY]?.name?.message}
      />

      <FormInputText
        id={`${STEP_KEY}.firmName`}
        label={LABELS.firmName}
        register={register}
        requiredField={false}
        error={errors?.[STEP_KEY]?.firmName?.message}
      />

      <FormInputEmail
        id={`${STEP_KEY}.email`}
        label={LABELS.email}
        register={register}
        requiredField={false}
        error={errors?.[STEP_KEY]?.email?.message}
      />

      <FormInputText
        id={`${STEP_KEY}.phoneNumber`}
        label={LABELS.phoneNumber}
        register={register}
        requiredField={false}
        error={errors?.[STEP_KEY]?.phoneNumber?.message}
      />

      <FormInputCurrency
        id={`${STEP_KEY}.feeAmount`}
        label={LABELS.feeAmount}
        register={register}
        requiredField={false}
        setValue={setValue}
        error={errors?.[STEP_KEY]?.feeAmount?.message}
      />

      <FormInputRadio
        id={`${STEP_KEY}.brokerFeeAddedToLoan`}
        label={LABELS.brokerFeeAddedToLoan}
        register={register}
        requiredField={false}
        initValue={brokerFeeAddedToLoan}
        error={errors?.[STEP_KEY]?.brokerFeeAddedToLoan?.message}
      />

      <FormInputRadio
        id={`${STEP_KEY}.lenderFeeAddedToLoan`}
        label={LABELS.lenderFeeAddedToLoan}
        register={register}
        requiredField={false}
        initValue={lenderFeeAddedToLoan}
        error={errors?.[STEP_KEY]?.lenderFeeAddedToLoan?.message}
      />

      <div className="!mt-8 border-t border-gray-200 pt-6">
        <span className="block text-base font-semibold">
          By submitting this application, you confirm that you have read and
          agree to the{" "}
          <a
            href={WEB_URLS.POLICIES.TERMS}
            target="_blank"
            rel="noreferrer"
            className="link underline"
          >
            Intermediary Terms and Conditions
          </a>
          , and have explained the nature of the mortgage product to the
          applicant(s), including discussing affordability.
        </span>
      </div>
    </div>
  );
};

export default BrokerDetailsForm;
